//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        disable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['init', 'credentials'],
};
